// extracted by mini-css-extract-plugin
export default {"btnForm":"ModalEditar_btnForm__XPZty"};